import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["country", "subregion"]
  static values = {
    subregions: String
  }

  connect() {
    this.refreshSubregions()
  }

  refreshSubregions() {
    if (!this.hasCountryTarget || !this.hasSubregionTarget) return

    const countryCode = this.countryTarget.value
    const selectedValue = this.subregionTarget.value
    const options = this.subregionMap[countryCode] || []

    this.subregionTarget.innerHTML = ""

    const blankOption = document.createElement("option")
    blankOption.value = ""
    blankOption.textContent = options.length > 0 ? "Select state / province / region" : "No curated regions for selected country"
    this.subregionTarget.appendChild(blankOption)

    options.forEach((entry) => {
      const option = document.createElement("option")
      option.value = entry.code
      option.textContent = `${entry.name} (${entry.code})`
      if (entry.code === selectedValue) {
        option.selected = true
      }
      this.subregionTarget.appendChild(option)
    })

    if (!options.some((entry) => entry.code === selectedValue)) {
      this.subregionTarget.value = ""
    }

    this.subregionTarget.disabled = options.length === 0
  }

  get subregionMap() {
    if (!this._subregionMap) {
      this._subregionMap = JSON.parse(this.subregionsValue || "{}")
    }

    return this._subregionMap
  }
}
